interface ISvgEmailProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgEmail: React.FC<ISvgEmailProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M36.6666 10C36.6666 8.16669 35.1666 6.66669 33.3333 6.66669H6.66659C4.83325 6.66669 3.33325 8.16669 3.33325 10V30C3.33325 31.8334 4.83325 33.3334 6.66659 33.3334H33.3333C35.1666 33.3334 36.6666 31.8334 36.6666 30V10ZM33.3333 10L19.9999 18.3334L6.66659 10H33.3333ZM33.3333 30H6.66659V13.3334L19.9999 21.6667L33.3333 13.3334V30Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgEmail;
